export default __webpack_public_path__ + "static/media/Vector-1.a26273c5.svg";